import cn from 'classnames';
import { useContext } from 'react';

import Button from 'components/common/Button';
import { VoucherContext } from 'components/signUpFunnel/Contexts';
import { AMEXBCE_PROMO_CODE } from 'lib/constants';
import styles from 'styles/components/signUpFunnel/promo/PromoCodeSection';

const AmexPromoApplied = ({
  handleChangePromoClickWithAnalytics,
  setErrorMessage,
  setHasPromo,
}) => {
  const { voucher } = useContext(VoucherContext);

  return (
    <div className={cn(styles.validatorBox, 'textMd pb-4 text-center')}>
      <p className="pb-4">
        American Express Blue Cash Everyday® Card Members can enroll and receive up to $15 in
        monthly statement credits for online purchases at Home Chef on their Blue Cash Everyday®
        Card. Shipping available in the contiguous US only.
      </p>
      <p className="pb-4">
        Not sure if your card is enrolled? Visit the American Express Benefits Dashboard to enroll
        your card.
      </p>
      {(!voucher || voucher.code === AMEXBCE_PROMO_CODE) && (
        <Button
          type="button"
          onClick={() => {
            setErrorMessage(null);
            setHasPromo(false);
            handleChangePromoClickWithAnalytics();
          }}
        >
          Add Promo Code or Gift Card
        </Button>
      )}
    </div>
  );
};

AmexPromoApplied.propTypes = {
  setErrorMessage: PropTypes.func.isRequired,
  setHasPromo: PropTypes.func.isRequired,
  handleChangePromoClickWithAnalytics: PropTypes.func.isRequired,
};

export default AmexPromoApplied;
